import { useSettings } from "../tools";
import { useCurrentMeeting } from "../contexts/currentMeeting";
import { useParticipantsStatus } from "./participantStatus";
import {
    SendParticipantCommandMutation,
    SendParticipantCommandDocument,
    SendParticipantCommandMutationVariables,
} from "./queries-chatto.generated";
import { useEffect } from "react";
import { CommandType } from "@/api";
import { useChattoHttpMutation } from "conference/apollo-client/chatto/hooks";

export const useMuteStateSynchronizer = () => {
    const settings = useSettings();
    const currentMeeting = useCurrentMeeting();
    const participantsStatus = useParticipantsStatus();

    const [sendCommand] = useChattoHttpMutation<
        SendParticipantCommandMutation,
        SendParticipantCommandMutationVariables
    >(SendParticipantCommandDocument);

    const remoteAudio = !participantsStatus[currentMeeting.selfUri]?.isMuted;

    const isSynchronized = settings.audio === remoteAudio;

    useEffect(() => {
        if (isSynchronized) return;

        sendCommand({
            variables: {
                command: {
                    roomId: currentMeeting.chatRoomId,
                    initiator: currentMeeting.selfUri,
                    target: currentMeeting.selfUri,
                    type: settings.audio ? CommandType.Unmute : CommandType.Mute,
                },
            },
        });
    }, [settings.audio]);

    useEffect(() => {
        if (isSynchronized) return;

        settings.audio = remoteAudio;
    }, [remoteAudio]);
};
